<div class="sales-order-picklist-confirm-action">
  <h2 mat-dialog-title>Failed to update order(s)</h2>
  <table class="lum-table lum-table--classic">
    <thead>
      <tr>
        <th>Order #</th>
        <th>Message</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let order of data?.orders">
        <td>{{ order?.orderNumber }}</td>
        <td>{{ order?.message }}</td>
        <td>
          <a [href]="'/shipping/picklists/' + order?.picklistId" target="_blank">
            <button mat-icon-button color="primary" [matTooltip]="'View picklist'">
              <mat-icon>open_in_new</mat-icon>
            </button>
          </a>
        </td>
      </tr>
    </tbody>
  </table>
  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Close</button>
  </mat-dialog-actions>
</div>
